export const translations = {
  it: {
    nav: {
      home: 'Home',
      weddings: 'Matrimoni',
      family: 'Famiglia & Coppia',
      events: 'Eventi & Aziende',
      portraits: 'Ritratti & Personal Branding',
      portfolio: 'Portfolio',
      about: 'Chi Sono',
      faq: 'FAQ',
      contact: 'Contatti'
    },
    hero: {
      title: 'Le emozioni più vere meritano di essere ricordate davvero',
      subtitle: 'Fotografie autentiche per chi vuole ricordare ciò che ha sentito',
      cta: 'Raccontami il vostro progetto'
    },
    home: {
      introTitle: 'Ciao, sono Matteo',
      introText: 'Credo che ogni fotografia nasca prima di tutto da un rapporto di fiducia. Per questo il mio lavoro non consiste solo nel creare immagini, ma nel mettere le persone a proprio agio, accompagnandole con discrezione e raccontandole per ciò che sono davvero.',
      visionTitle: 'La Mia Visione',
      visionText: 'Più che cercare la fotografia perfetta, cerco persone che si sentano libere di essere sé stesse. Perché è proprio in quei momenti che nascono le immagini più autentiche.',
      servicesTitle: 'Servizi',
      approachTitle: 'Il Mio Approccio',
      approachText: 'Non sono solo un fotografo, sono qualcuno che vi accompagna nei vostri momenti più importanti. Vi sostengo, vi guido con discrezione, e creo con voi un rapporto di fiducia che si riflette nelle immagini.'
    },
    weddings: {
      title: 'Matrimoni',
      subtitle: 'Reportage Autentico ed Elegante',
      description: 'Il vostro matrimonio è unico. Merita di essere raccontato con autenticità, emozione e stile. Vi aiuto a vivere davvero la vostra giornata, senza ansie, catturando ogni momento prezioso.',
      cta: 'Raccontami del vostro matrimonio'
    },
    family: {
      title: 'Famiglia, Coppia & Maternity',
      subtitle: 'Momenti Intimi e Naturali',
      description: 'Ogni famiglia ha la sua storia. Ogni coppia ha il suo legame unico. Ogni attesa è magica. Creiamo insieme ricordi autentici che dureranno per sempre.',
      cta: 'Regalati un ricordo'
    },
    events: {
      title: 'Eventi & Aziende',
      subtitle: 'Professionalità e Creatività',
      description: 'Eventi aziendali, concerti, sport, branding. Ogni progetto merita un approccio professionale e creativo che catturi l\'essenza del momento.',
      cta: 'Parliamo del vostro progetto'
    },
    portraits: {
      title: 'Ritratti & Personal Branding',
      subtitle: 'Ogni persona ha una storia da raccontare.',
      heroSubtitle: 'Che si tratti di un progetto personale, professionale o artistico, ogni ritratto nasce dall\'incontro tra luce, emozioni e autenticità.',
      cta: 'Prenota la tua sessione',
      intro: 'Un ritratto non è riservato a modelli o professionisti. È un\'esperienza pensata per chi desidera valorizzare la propria immagine, raccontare una parte di sé, rafforzare la propria presenza professionale o dare vita a un progetto artistico. L\'obiettivo è creare fotografie autentiche, eleganti e senza tempo, nelle quali ogni persona possa riconoscersi.',
      servicesTitle: 'Le tipologie di servizio',
      service1Title: 'Ritratti personali',
      service1Text: 'Per chi desidera regalarsi un\'esperienza fotografica, celebrare un momento importante o semplicemente avere immagini autentiche che raccontino la propria personalità.',
      service2Title: 'Personal Branding & Aziende',
      service2Text: 'Per professionisti, imprenditori, creativi e aziende che desiderano comunicare la propria identità attraverso fotografie moderne, curate e professionali.',
      service3Title: 'Progetti artistici',
      service3Text: 'Sessioni fotografiche pensate per sviluppare idee, concept creativi, ricerca espressiva o immagini dal forte impatto visivo, costruite insieme partendo dalla tua visione.',
      service4Title: 'Studio o Outdoor',
      service4Text: 'Ogni progetto viene costruito in base alla persona e alla storia che desidera raccontare. Le sessioni possono essere realizzate sia in studio che in esterna, scegliendo l\'ambiente più adatto per creare immagini coerenti con il risultato desiderato e valorizzare al meglio ogni progetto.',
      approachTitle: 'Il mio approccio',
      approachText: 'Non ricerco pose perfette, ma autenticità. Ogni sessione è pensata per mettere la persona a proprio agio, creando un clima rilassato che permetta di ottenere immagini spontanee, eleganti e capaci di rappresentarla davvero.',
      portfolioTitle: 'Portfolio',
      faqTitle: 'Domande Frequenti',
      faq1Q: 'Non sono mai stato davanti a una fotocamera, va bene lo stesso?',
      faq1A: 'Assolutamente sì! La maggior parte delle persone che fotografo non ha esperienza davanti all\'obiettivo. Il mio approccio è pensato proprio per farti sentire a tuo agio: ti guiderò durante tutta la sessione con suggerimenti naturali, creando un clima rilassato che ti permetterà di essere te stesso.',
      faq2Q: 'È possibile realizzare la sessione in esterna?',
      faq2A: 'Certamente! Ogni progetto viene costruito insieme in base alle tue esigenze e alla storia che vuoi raccontare. Possiamo scegliere location outdoor che rispecchino la tua personalità, oppure lavorare in studio per un risultato più controllato ed elegante.',
      faq3Q: 'Quanto dura una sessione fotografica?',
      faq3A: 'La durata varia in base al tipo di servizio: un ritratto personale dura circa 1-2 ore, mentre un progetto di personal branding o artistico può richiedere 2-3 ore o più, a seconda della complessità e del numero di look o location.',
      faq4Q: 'Posso utilizzare queste fotografie per il mio lavoro o i miei profili professionali?',
      faq4A: 'Assolutamente! Riceverai tutte le immagini in alta risoluzione con i diritti di utilizzo per uso personale e professionale, inclusi siti web, social media, materiali di marketing e presentazioni.',
      faq5Q: 'È possibile realizzare un progetto artistico o una sessione fotografica completamente personalizzata?',
      faq5A: 'Sì! Ogni servizio può essere progettato insieme, sviluppando un\'idea, un concept creativo o un\'esigenza specifica, sia personale che professionale. Che tu abbia già una visione chiara o voglia costruirla insieme, lavoreremo per dare vita a immagini uniche che parlano davvero di te.',
      ctaTitle: 'Raccontiamo insieme la tua storia',
      ctaText: '',
      ctaButton: 'Prenota la tua sessione'
    },
    portfolio: {
      title: 'Portfolio',
      weddings: 'Matrimoni',
      family: 'Famiglia',
      events: 'Eventi'
    },
    about: {
      title: 'Chi Sono',
      subtitle: 'Matteo Giacometti',
      story: 'Sono un fotografo professionista appassionato di storie umane. La mia missione è catturare emozioni autentiche e creare ricordi che durano nel tempo. Con empatia, discrezione e un occhio per i dettagli, accompagno le persone nei loro momenti più importanti.'
    },
    faq: {
      title: 'Domande Frequenti',
      q1: 'Come funziona il primo contatto?',
      a1: 'Ogni servizio inizia con una chiacchierata senza impegno. Mi piace capire chi siete, cosa desiderate e consigliarvi la soluzione più adatta alle vostre esigenze.',
      q2: 'Lavori solo in Veneto?',
      a2: 'No. Mi sposto volentieri anche in altre regioni e all\'estero. Ogni progetto viene organizzato insieme in base alla destinazione.',
      q3: 'Come posso prenotare un servizio?',
      a3: 'È sufficiente contattarmi tramite il form del sito o sui miei canali. Vi risponderò nel più breve tempo possibile per fissare una chiamata o un incontro.',
      q4: 'Come fai a mettere a proprio agio chi non ama stare davanti alla macchina fotografica?',
      a4: 'La maggior parte delle persone non è abituata a essere fotografata. Il mio compito è creare un\'atmosfera serena e naturale, così da raccontare emozioni autentiche senza forzature.',
      q5: 'Realizzi servizi personalizzati?',
      a5: 'Sì. Ogni persona, coppia o famiglia è diversa e ogni servizio viene costruito sulle esigenze di chi ho davanti. Per qualsiasi richiesta particolare sarà sufficiente contattarmi.',
      q6: 'Quando è il momento migliore per prenotare?',
      a6: 'Prima ci sentiamo e maggiori saranno le possibilità di scegliere la data ideale. Se invece avete esigenze dell\'ultimo momento, contattatemi comunque: se possibile troveremo una soluzione.',
      q7: 'Come riceverò le fotografie?',
      a7: 'Ogni consegna viene curata con attenzione e pensata per offrire la migliore esperienza possibile. Durante la nostra consulenza vi spiegherò nel dettaglio tutte le modalità disponibili.',
      q8: 'Posso regalare uno shooting fotografico?',
      a8: 'Assolutamente sì. È un regalo originale ed emozionante che rimane nel tempo. Contattami per conoscere le soluzioni disponibili.'
    },
    contact: {
      title: 'Contatti',
      subtitle: 'Raccontami del Tuo Progetto',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefono',
      service: 'Servizio',
      message: 'Messaggio',
      send: 'Invia Messaggio',
      success: 'Messaggio inviato con successo!',
      error: 'Errore nell\'invio del messaggio. Riprova.',
      selectService: 'Seleziona un servizio',
      wedding: 'Matrimonio',
      familyService: 'Famiglia/Coppia/Maternity',
      eventsService: 'Eventi/Aziende',
      portraitsService: 'Ritratti & Personal Branding'
    },
    footer: {
      rights: 'Tutti i diritti riservati',
      follow: 'Seguimi'
    }
  },
  en: {
    nav: {
      home: 'Home',
      weddings: 'Weddings',
      family: 'Family & Couples',
      events: 'Events & Corporate',
      portraits: 'Portraits & Personal Branding',
      portfolio: 'Portfolio',
      about: 'About',
      faq: 'FAQ',
      contact: 'Contact'
    },
    hero: {
      title: 'The truest emotions deserve to be truly remembered',
      subtitle: 'Authentic photography for those who want to remember what they felt',
      cta: 'Tell me about your project'
    },
    home: {
      introTitle: 'Hi, I\'m Matteo',
      introText: 'I believe that every photograph is born first of all from a relationship of trust. That\'s why my work isn\'t just about creating images, but about making people feel comfortable, accompanying them discreetly and capturing them for who they really are.',
      visionTitle: 'My Vision',
      visionText: 'Rather than seeking the perfect photograph, I seek people who feel free to be themselves. Because it\'s in those moments that the most authentic images are born.',
      servicesTitle: 'Services',
      approachTitle: 'My Approach',
      approachText: 'I\'m not just a photographer, I\'m someone who accompanies you in your most important moments. I support you, guide you discreetly, and create with you a relationship of trust that is reflected in the images.'
    },
    weddings: {
      title: 'Weddings',
      subtitle: 'Authentic and Elegant Reportage',
      description: 'Your wedding is unique. It deserves to be told with authenticity, emotion and style. I help you truly live your day, without anxiety, capturing every precious moment.',
      cta: 'Tell me about your wedding'
    },
    family: {
      title: 'Family, Couples & Maternity',
      subtitle: 'Intimate and Natural Moments',
      description: 'Every family has its story. Every couple has its unique bond. Every wait is magical. Let\'s create authentic memories together that will last forever.',
      cta: 'Let\'s create something authentic'
    },
    events: {
      title: 'Events & Corporate',
      subtitle: 'Professionalism and Creativity',
      description: 'Corporate events, concerts, sports, branding. Every project deserves a professional and creative approach that captures the essence of the moment.',
      cta: 'Let\'s talk about your project'
    },
    portraits: {
      title: 'Portraits & Personal Branding',
      subtitle: 'Everyone has a story to tell.',
      heroSubtitle: 'Whether it\'s a personal, professional or artistic project, every portrait is born from the meeting of light, emotions and authenticity.',
      cta: 'Book your session',
      intro: 'A portrait is not reserved for models or professionals. It\'s an experience designed for those who want to enhance their image, tell a part of themselves, strengthen their professional presence or bring an artistic project to life. The goal is to create authentic, elegant and timeless photographs in which everyone can recognize themselves.',
      servicesTitle: 'Service types',
      service1Title: 'Personal portraits',
      service1Text: 'For those who want to treat themselves to a photographic experience, celebrate an important moment or simply have authentic images that tell their personality.',
      service2Title: 'Personal Branding & Corporate',
      service2Text: 'For professionals, entrepreneurs, creatives and companies who want to communicate their identity through modern, curated and professional photographs.',
      service3Title: 'Artistic projects',
      service3Text: 'Photo sessions designed to develop ideas, creative concepts, expressive research or images with strong visual impact, built together starting from your vision.',
      service4Title: 'Studio or Outdoor',
      service4Text: 'Each project is built based on the person and the story they want to tell. Sessions can be done both in studio and outdoors, choosing the most suitable environment to create images consistent with the desired result and enhance each project.',
      approachTitle: 'My approach',
      approachText: 'I don\'t look for perfect poses, but authenticity. Each session is designed to make the person feel comfortable, creating a relaxed atmosphere that allows to obtain spontaneous, elegant images capable of truly representing them.',
      portfolioTitle: 'Portfolio',
      faqTitle: 'Frequently Asked Questions',
      faq1Q: 'I\'ve never been in front of a camera, is that okay?',
      faq1A: 'Absolutely! Most people I photograph have no experience in front of the lens. My approach is designed to make you feel comfortable: I will guide you throughout the session with natural suggestions, creating a relaxed atmosphere that will allow you to be yourself.',
      faq2Q: 'Is it possible to do the session outdoors?',
      faq2A: 'Certainly! Each project is built together based on your needs and the story you want to tell. We can choose outdoor locations that reflect your personality, or work in the studio for a more controlled and elegant result.',
      faq3Q: 'How long does a photo session last?',
      faq3A: 'Duration varies by service type: a personal portrait lasts about 1-2 hours, while a personal branding or artistic project may require 2-3 hours or more, depending on complexity and number of looks or locations.',
      faq4Q: 'Can I use these photos for my work or professional profiles?',
      faq4A: 'Absolutely! You will receive all images in high resolution with usage rights for personal and professional use, including websites, social media, marketing materials and presentations.',
      faq5Q: 'Is it possible to create an artistic project or completely customized photo session?',
      faq5A: 'Yes! Every service can be designed together, developing an idea, a creative concept or a specific need, both personal and professional. Whether you already have a clear vision or want to build it together, we will work to create unique images that truly speak about you.',
      ctaTitle: 'Let\'s tell your story together.',
      ctaText: 'Everyone has something unique to tell. Whether it\'s a personal portrait, a personal branding project or an artistic idea, together we will create images that truly speak about you.',
      ctaButton: 'Book your session'
    },
    portfolio: {
      title: 'Portfolio',
      weddings: 'Weddings',
      family: 'Family',
      events: 'Events'
    },
    about: {
      title: 'About Me',
      subtitle: 'Matteo Giacometti',
      story: 'I am a professional photographer passionate about human stories. My mission is to capture authentic emotions and create memories that last over time. With empathy, discretion and an eye for detail, I accompany people in their most important moments.'
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'How does the first contact work?',
      a1: 'Every service begins with a no-obligation chat. I like to understand who you are, what you want, and recommend the best solution for your needs.',
      q2: 'Do you work only in Veneto?',
      a2: 'No. I\'m happy to travel to other regions and abroad as well. Every project is organized together based on the destination.',
      q3: 'How can I book a service?',
      a3: 'Simply contact me through the website form or my channels. I\'ll respond as soon as possible to schedule a call or meeting.',
      q4: 'How do you make people who don\'t like being in front of the camera feel comfortable?',
      a4: 'Most people aren\'t used to being photographed. My job is to create a serene and natural atmosphere, capturing authentic emotions without forcing anything.',
      q5: 'Do you create personalized services?',
      a5: 'Yes. Every person, couple, or family is different, and each service is tailored to the needs of those in front of me. For any particular request, just contact me.',
      q6: 'When is the best time to book?',
      a6: 'The sooner we connect, the better the chances of choosing your ideal date. If you have last-minute needs, contact me anyway: if possible, we\'ll find a solution.',
      q7: 'How will I receive the photographs?',
      a7: 'Every delivery is carefully curated and designed to offer the best possible experience. During our consultation, I\'ll explain all available options in detail.',
      q8: 'Can I gift a photo shoot?',
      a8: 'Absolutely. It\'s an original and emotional gift that lasts over time. Contact me to learn about available options.'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Tell Me About Your Project',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      service: 'Service',
      message: 'Message',
      send: 'Send Message',
      success: 'Message sent successfully!',
      error: 'Error sending message. Please try again.',
      selectService: 'Select a service',
      wedding: 'Wedding',
      familyService: 'Family/Couples/Maternity',
      eventsService: 'Events/Corporate',
      portraitsService: 'Portraits & Personal Branding'
    },
    footer: {
      rights: 'All rights reserved',
      follow: 'Follow me'
    }
  }
};

export const t = (key, lang = 'it') => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value || key;
};
